import { BaseProps } from '@/components/types'
import { ReactElement, cloneElement } from 'react'
import '@/assets/scss/app/card-table-layout.scss'
function DefaultTableLayout ( props: DefaultTableLayoutProps ) {
    const {
        title, height, actions,
        children,
        ...rest
    } = props

    return (
        <div className="card-table-layout-container" style={ { height, margin: '8px 0 8px 0'} }>
            <div className="card-table-layout-header">
                <div className="card-table-layout-header-title">
                    { title && <span>{ title }</span> }
                </div>
                <div className="card-table-layout-header-actions" style={ { padding: '4px' } }>
                    { actions && actions }
                </div>
            </div>
            <div className="card-table-layout-content">
                { children && cloneElement( children, { ...rest } ) }
            </div>
        </div>
    )
}

export default DefaultTableLayout

export interface DefaultTableLayoutProps extends BaseProps {
    title?: string
    height?: string | number
    actions?: ReactElement
}